/* eslint-disable max-len */
/* eslint-disable react/jsx-indent */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate, I18n } from 'react-redux-i18n';

import NumbersHelper from '../../helpers/numbers';
import WizzardOrdersComponent from './wizzard';

import PurchaseData from '../../data/translate';

import OrderAction from '../../app/store/actions/orders';

class OrdersComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderProcess: '',
    };
  }

  getCalculateDiscount = (items = []) => {
    const discountValues = items.reduce((total, item) => total + parseFloat(item.descontoValor), 0);

    return discountValues;
  }

  getCartTotal = (items = [], valorOfProduct = false, noDiscount = false) => {
    const itemsValues = items.reduce((total, item) => total
      + ((parseInt(item.price, 10) * parseInt(item.amount, 10)) - ((!noDiscount) ? parseFloat(item.descontoValor || 0) : 0)),
    0);
    if (valorOfProduct) return itemsValues;
    return Math.round(itemsValues + (itemsValues * parseFloat(this.props.taxFixedValue)));
  }

  orderStatus = (status) => {
    if (status === PurchaseData.orderStatus.CONFIRMED) return I18n.t('approved');
    if (status === PurchaseData.orderStatus.PAID) return I18n.t('paid');
    if (status === PurchaseData.orderStatus.PROCESSED) return I18n.t('paid');
    if (status === PurchaseData.orderStatus.DELIVERED) return I18n.t('delivered');
    if (status === PurchaseData.orderStatus.CANCELED) return I18n.t('canceled');
  }

  paymentType = (payment) => {
    if (payment === PurchaseData.paymentType.CREDIT) return I18n.t('credit');
    if (payment === PurchaseData.paymentType.DEBIT) return I18n.t('debit');
    if (payment === PurchaseData.paymentType.BANK_SLIP) return I18n.t('bankSlip');
    if (payment === PurchaseData.paymentType.BILLING) return I18n.t('billing');
    if (payment === PurchaseData.paymentType.ESTIMATE) return I18n.t('estimate');
    if (payment === PurchaseData.paymentType.GETNET) return I18n.t('getnetTypeOPayment');
  }

  paymentStatus = (payment) => {
    if (!payment) return I18n.t('notDefined');
    if (payment === PurchaseData.paymentStatus.INDEFINITE) return I18n.t('undefined');
    if (payment === PurchaseData.paymentStatus.AUTHORIZED) return I18n.t('authorized');
    if (payment === PurchaseData.paymentStatus.NOT_AUTHORIZED) return I18n.t('notAuthorized');
    if (payment === PurchaseData.paymentStatus.CANCELED) return I18n.t('canceled');
    if (payment === PurchaseData.paymentStatus.CAPTURED) return I18n.t('captured');

    // PAGSEGURO
    if (payment === PurchaseData.paymentStatusPagSeguro.AWAIT_PAYMENT) return I18n.t('awaitPayment');
    if (payment === PurchaseData.paymentStatusPagSeguro.PAID) return I18n.t('authorized');
    if (payment === PurchaseData.paymentStatusPagSeguro.RETURNED) return I18n.t('notAuthorized');
    if (payment === PurchaseData.paymentStatusPagSeguro.CANCELED) return I18n.t('canceled');
    if (payment === PurchaseData.paymentStatusPagSeguro.DEBITED) return I18n.t('captured');

    // GETNET
    if (payment === PurchaseData.paymentStatusGetnet.APPROVED) return I18n.t('approved3');
    if (payment === PurchaseData.paymentStatusGetnet.REJECTED) return I18n.t('refused');
  }

  cancelOrder = async (orderId) => {
    await this.props.cancelOrder(orderId);
    this.props.closeModal();
  }
  componentDidMount = () => {
    this.orderInformationAboutFreight()
  }

  orderInformationAboutFreight = async () => {
    const { items, companyTag } = this.props;
    if (companyTag === 'nortel') {
      this.setState({
        orderProcess: await this.props.getOrderProcess(items.id)
      })
    }
  }

  render() {
    const { items, easyConfirm, companyTag } = this.props;

    return (
      <div className="row justify-content-center">
        {(this.props.companyTag === 'nortel')
          ? <WizzardOrdersComponent order={this.state.orderProcess} easyConfirm={easyConfirm} companyTag={this.props.companyTag} easyConfirmVersion={this.props.easyConfirmVersion} />
          : <WizzardOrdersComponent order={items} easyConfirm={easyConfirm} companyTag={this.props.companyTag} />
        }
        <div className="orders-modal-main">
          <span className="title-order-details">
            <Translate value="orderDetails" />
          </span>
          {(items.status === PurchaseData.orderStatus.PAID
            || items.status === PurchaseData.orderStatus.PROCESSED
            || items.status === PurchaseData.orderStatus.CONFIRMED) && (
              <button
                type="button"
                className="btn btn-danger btn-sm btn-cancel"
                onClick={() => this.cancelOrder(items.id)}
              >
                <Translate value="cancelOrder" />
              </button>
          )}
          <table className="table table-mini-cart">
            <tbody>
              <tr>
                <td>
                  Código:
                  {' '}
                  <strong>{items.id}</strong>
                </td>
                {!!items.sphereNumber && (
                  <td>
                    Código Sphere:
                    {' '}
                    <strong>{items.sphereNumber}</strong>
                  </td>
                )}

                {!!items.savedId && (
                  <td>
                    <Translate value="codeSolicitation" />
                    {' '}
                    &nbsp;
                    <strong>{items.savedId}</strong>
                  </td>
                )}
              </tr>
              <tr>
                <td>
                  {items.paymentType && (
                    <React.Fragment>
                      <p className="margin-bottom-0">
                        <Translate value="paymentType" />
                        :&nbsp;
                        <strong>{this.paymentType(items.paymentType)}</strong>
                      </p>
                      {(companyTag === 'chile' && 
                      items.sphereOrcamento &&
                      items.paymentType === 'estimate' && 
                      items.sphereOrcamento.regStatus === 'PED' &&
                      items.sphereOrcamento.statusProcesso === "fechado") && (
                        <strong>{I18n.t('estimateConvertedToOrder')}</strong>
                      )}
                    </React.Fragment>
                  )}
                </td>
                <td>
                  {!!items.status && (
                    <p className="margin-bottom-0">
                      <Translate value="paymentStatus" />
                      :&nbsp;<strong>{(items.reasonTranslation && companyTag === 'chile')
                        ? items.reasonTranslation
                        : this.paymentStatus(items.paymentStatus)
                      }</strong>
                    </p>
                  )}
                  {!!items.paymentData && !!items.paymentData.Payment && !!items.paymentData.Payment.ProviderReturnCode && (
                    <p className="margin-bottom-0">
                      <Translate value="providerReturn" />
                        :&nbsp;
                      <strong>{items.paymentData.Payment.ProviderReturnCode}</strong>
                    </p>
                  )}
                </td>
              </tr>
              <tr>
                {items.value && (
                  <td>
                    <Translate value="price" />
                    :&nbsp;
                 
                    {items.couponId && (
                      <strong style={items.couponId ? { textDecoration: 'line-through' } : {}}>
                        {NumbersHelper.toCurrency(this.getCartTotal(items.items, false, true))}
                        &nbsp;&nbsp;
                      </strong>
                    )}
                    <strong>
                      {NumbersHelper.toCurrency(items.value)}
                    </strong>
                  </td>
                )}
                <td>
                  <Translate value="buyDate" />
                  :&nbsp;
                  <strong>{items.createdAt}</strong>
                </td>
              </tr>
              <tr>
                {items.address && (
                  <td>
                    <h4>
                      <div className="checkout-resume">
                        <Translate value="addressToSend" />
                      </div>
                    </h4>
                    <p className="margin-bottom-0">{items.address.name}</p>
                    <p className="margin-bottom-0">{items.address.address}</p>
                    <p className="margin-bottom-0">{items.address.province}</p>
                    <p className="margin-bottom-0">{`${items.address.city} - ${items.address.state}`}</p>
                    <p className="margin-bottom-0">{items.address.cep}</p>
                    <p>{items.address.country}</p>
                  </td>
                )}
              </tr>
              <tr>
                <td>
                  <h4>
                    {items.items.length}
                    {' '}
                    <Translate value="productBought" />
                  </h4>
                </td>
              </tr>

              {items.items.map(item => (
                <tr key={item.productId}>
                  <td className="product-col">
                    <div>
                      {companyTag === 'nortel' && (
                        <p>
                          {`( ${I18n.t('code2')} ${item.purchaseProduct.code || ''} ) `}
                          {`( ${I18n.t('soneparCode')} ${item.purchaseProduct.soneparId || ''} ) `}
                          {`( ${I18n.t('clientCode')} ${item.productClientCode || ''} ) `}
                        </p>
                      )}
                      <p className="product-title">
                        {item.purchaseProduct.description}
                      </p>
                      <span className="product-qty">
                        <Translate value="quantity" />
                        {item.amount}
                      </span>
                    </div>
                  </td>
                  <td className="price-col">
                    {NumbersHelper.toCurrency(item.price)}
                  </td>
                </tr>
              ))}
            </tbody>

            <tfoot>
              {items.couponId && (
                <tr>
                  <td className="font-weight-899"><Translate value="discount" /></td>
                  <td className="font-weight-899">
                    {NumbersHelper.toCurrency(this.getCalculateDiscount(items.items))}
                  </td>
                </tr>
              )}
              <tr>
                <td className="font-weight-899"><Translate value="total" /></td>
                <td className="font-weight-899">
                  {NumbersHelper.toCurrency(this.getCartTotal(items.items, true, false))}
                </td>
              </tr>
              <tr>
                <td className="font-weight-899"><Translate value="freight" /></td>
                <td>
                  {items.client.freight ? items.client.freight : '----'}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  cancelOrder: orderId => dispatch(OrderAction.cancelOrder(orderId)),
  getOrderProcess: (id) => dispatch(OrderAction.getOrderProcess(id))
});

const mapStateToProps = state => ({
  easyConfirm: state.settings.confirmaFacil,
  easyConfirmVersion: state.settings.confirmaFacilVersion,
  companyTag: state.settings && state.settings.companyTag,
  taxFixedValue: state.settings && state.settings.taxFixedValue,
});

export default connect(mapStateToProps, mapDispatchToProps)(OrdersComponent);
